import index from './pages/index'

const routes = [
    {
        path: '/about',
        name: 'About',
        component: index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/about/routes.js